import React, { useEffect, useState } from 'react';
import { FaMoneyBillWave, FaChartLine, FaClipboardCheck, FaUndo } from 'react-icons/fa';
import ChartComponent from './ChartComponent';
import api from '../../utils/api';

const DashboardAdmin = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get('/api/orders/dashboard');
        setStats(res.data.stats);
      } catch (err) {
        console.error('Error al cargar estadísticas:', err);
        setError('No se pudieron cargar las estadísticas');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const getCurrentDateTime = () => {
    return new Date().toLocaleString('es-ES', {
      dateStyle: 'long',
      timeStyle: 'short',
    });
  };

  return (
    <div className="bg-[oklch(97%_0.014_254.604)] min-h-screen py-8 px-4 sm:px-6 lg:px-8 font-[Manrope]">
      <div className="mx-auto max-w-7xl">
        <div className="bg-white rounded-xl shadow-sm p-6">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">¡Hola, Lorenzo Picado!</h1>
            <p className="text-sm text-gray-500 mt-1">{getCurrentDateTime()}</p>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mb-6">Panel de Administración</h2>

          {loading ? (
            <p className="text-gray-500">Cargando estadísticas...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : stats ? (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
              {/* Gráfico */}
              <div className="lg:col-span-2">
                <ChartComponent
                  type="area"
                  data={stats.salesMonthlyData || []}
                  dataKey1="total"
                  label1="Ventas"
                  title="Crecimiento Mensual de Ventas"
                  color1="#1E3A8A"
                />
              </div>

              {/* Métricas */}
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg border flex items-center gap-4">
                  <FaChartLine className="text-blue-700 text-2xl" />
                  <div>
                    <p className="text-sm text-gray-600">Ventas este mes</p>
                    <p className="text-lg font-semibold text-gray-900">${stats.mesActual.toFixed(2)}</p>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg border flex items-center gap-4">
                  <FaMoneyBillWave className="text-blue-700 text-2xl" />
                  <div>
                    <p className="text-sm text-gray-600">Ventas totales</p>
                    <p className="text-lg font-semibold text-gray-900">${stats.ventaReal.toFixed(2)}</p>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg border flex items-center gap-4">
                  <FaClipboardCheck className="text-blue-700 text-2xl" />
                  <div>
                    <p className="text-sm text-gray-600">Pedidos completados</p>
                    <p className="text-lg font-semibold text-gray-900">{stats.completados}</p>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg border flex items-center gap-4">
                  <FaUndo className="text-blue-700 text-2xl" />
                  <div>
                    <p className="text-sm text-gray-600">Reembolsados</p>
                    <p className="text-lg font-semibold text-gray-900">{stats.reembolsados}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-red-500">No se encontraron estadísticas.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardAdmin;
